import { useState } from "react";
import { CaretDown, CaretRight, NotePencil, ArrowClockwise, CheckCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import ManualEntryPanel from "./raw/ManualEntryPanel";

// Second entry point to the same Raw Data manual submission (same component, API, duplicate rules and audit fields).
export function InlineManualEntry({ onRefresh }) {
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(0);
  const [busy, setBusy] = useState(false);
  const refresh = async () => { setBusy(true); try { await onRefresh(); setSaved(0); } finally { setBusy(false); } };
  return (
    <div className="mt-4 rounded-xl border-2 border-[#f59e0b]/60 bg-[#f59e0b]/[0.04]" data-testid="inline-manual-entry">
      <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2">
        <button type="button" onClick={() => setOpen((v) => !v)} className="inline-flex items-center gap-2 text-sm font-bold text-[#d97706]" data-testid="inline-manual-entry-toggle" aria-expanded={open}>
          {open ? <CaretDown size={14} weight="bold" /> : <CaretRight size={14} weight="bold" />}<NotePencil size={15} /> Manual Entry
          <span className="font-normal text-xs text-slate-500">Fill in missing days without leaving this page</span>
        </button>
        {saved > 0 && (
          <Button size="sm" onClick={refresh} disabled={busy} className="bg-[#f59e0b] hover:bg-[#d97706] text-white h-8" data-testid="inline-manual-refresh-audit">
            <ArrowClockwise size={14} className={`mr-1.5 ${busy ? "animate-spin" : ""}`} />{busy ? "Refreshing…" : "Refresh Entry Audit"}
          </Button>
        )}
      </div>
      {saved > 0 && (
        <div className="mx-3 mb-2 text-xs text-emerald-700 inline-flex items-center gap-1" data-testid="inline-manual-saved-msg">
          <CheckCircle size={13} /> Saved. Press Refresh Entry Audit to update the audit, KPI tables and payroll.
        </div>
      )}
      {open && (
        <div className="px-3 pb-1">
          <ManualEntryPanel onClose={() => setOpen(false)} onSaved={() => setSaved((n) => n + 1)} />
        </div>
      )}
    </div>
  );
}
